import { useRef, useState } from "react";

/**
 * BeforeAfterSlider — drag the divider to compare two images.
 * Premium-friendly: works on touch + mouse, pure CSS layer, no deps.
 */
export default function BeforeAfterSlider({
  beforeSrc,
  afterSrc,
  beforeLabel = "Before",
  afterLabel = "Now",
  testId = "before-after-slider",
}) {
  const wrapRef = useRef(null);
  const [pos, setPos] = useState(50); // percentage 0..100
  const draggingRef = useRef(false);

  const handleMove = (clientX) => {
    const el = wrapRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const pct = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
    setPos(pct);
  };
  const onPointerDown = (e) => {
    draggingRef.current = true;
    e.currentTarget.setPointerCapture?.(e.pointerId);
    handleMove(e.clientX);
  };
  const onPointerMove = (e) => {
    if (!draggingRef.current) return;
    handleMove(e.clientX);
  };
  const onPointerUp = (e) => {
    draggingRef.current = false;
    e.currentTarget.releasePointerCapture?.(e.pointerId);
  };

  return (
    <div className="ba-slider" ref={wrapRef} data-testid={testId}
         onPointerDown={onPointerDown} onPointerMove={onPointerMove}
         onPointerUp={onPointerUp} onPointerCancel={onPointerUp}>
      <img src={beforeSrc} alt="Before" className="ba-img" draggable={false}/>
      <div className="ba-after" style={{ width: `${pos}%` }}>
        <img src={afterSrc} alt="Now" className="ba-img" draggable={false} style={{ width: `${10000 / Math.max(pos, 1)}%` }}/>
      </div>
      <div className="ba-divider" style={{ left: `${pos}%` }}>
        <div className="ba-knob"><span/><span/></div>
      </div>
      <span className="ba-label left">{beforeLabel}</span>
      <span className="ba-label right">{afterLabel}</span>
    </div>
  );
}
